"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTableRowCssClassForStatus = exports.getTableColumnsConfig = exports["default"] = exports.SelectedItemsSummary = void 0;
Object.defineProperty(exports, "selectedItemStatus", {
  enumerable: true,
  get: function get() {
    return _selectedItemStatusEnum["default"];
  }
});
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DataTable = _interopRequireDefault(require("../data-table/DataTable"));
var _ColumnButtons = _interopRequireDefault(require("./ColumnButtons"));
var _StatusColumn = _interopRequireDefault(require("./StatusColumn"));
var _selectedItemStatusEnum = _interopRequireDefault(require("./selectedItemStatusEnum"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var getTableRowCssClassForStatus = function getTableRowCssClassForStatus(status) {
  switch (status) {
    case _selectedItemStatusEnum["default"].CAN_BE_ADDED:
      return 'can-be-added';
    case _selectedItemStatusEnum["default"].WILL_BE_ADDED:
      return 'will-be-added';
    case _selectedItemStatusEnum["default"].WILL_BE_REMOVED:
      return 'will-be-removed';
    case _selectedItemStatusEnum["default"].WILL_BE_AUTO_REMOVED:
    case _selectedItemStatusEnum["default"].WILL_BE_REMOVED_WILL_BE_AUTO_REMOVED:
    case _selectedItemStatusEnum["default"].WILL_BE_ADDED_WILL_BE_AUTO_REMOVED:
      return 'will-be-auto-removed';
    default:
      return '';
  }
};
exports.getTableRowCssClassForStatus = getTableRowCssClassForStatus;
var getTableColumnsConfig = function getTableColumnsConfig(columns, idFieldName, handleItemWillBeRemoved, handleUndoItemWillBeAdded, handleUndoItemWillBeRemoved, handleItemWillBeAdded, disabled, showStatusColumn) {
  var cols = columns ? _toConsumableArray(columns) : [{
    field: "name"
  }];
  if (showStatusColumn) {
    cols.push({
      render: [{
        component: /*#__PURE__*/_react["default"].createElement(_StatusColumn["default"], null),
        mapFieldsToProps: {
          "status": "status"
        }
      }] // eslint-disable-line react/jsx-key
    });
  }

  return [].concat(_toConsumableArray(cols), [{
    tdClassName: "buttons-column",
    render: [{
      component: /*#__PURE__*/_react["default"].createElement(_ColumnButtons["default"], {
        disabled: disabled || false,
        onItemWillBeAdded: handleItemWillBeAdded,
        onUndoItemWillBeAdded: handleUndoItemWillBeAdded,
        onUndoItemWillBeRemoved: handleUndoItemWillBeRemoved,
        onItemWillBeRemoved: handleItemWillBeRemoved
      }),
      mapFieldsToProps: {
        status: "status",
        id: idFieldName || "id"
      }
    }]
  }]);
};
exports.getTableColumnsConfig = getTableColumnsConfig;
var SelectedItemsSummary = function SelectedItemsSummary(_ref) {
  var items = _ref.items,
    onItemWillBeRemoved = _ref.onItemWillBeRemoved,
    onUndoItemWillBeAdded = _ref.onUndoItemWillBeAdded,
    onUndoItemWillBeRemoved = _ref.onUndoItemWillBeRemoved,
    onItemWillBeAdded = _ref.onItemWillBeAdded,
    showStatusColumn = _ref.showStatusColumn,
    columns = _ref.columns,
    idFieldName = _ref.idFieldName,
    disabled = _ref.disabled,
    noItemsMessage = _ref.noItemsMessage,
    className = _ref.className,
    style = _ref.style,
    showTableHeader = _ref.showTableHeader,
    showTableBorders = _ref.showTableBorders,
    condensed = _ref.condensed,
    onColumnSort = _ref.onColumnSort,
    columnSortDirection = _ref.columnSortDirection,
    columnSortField = _ref.columnSortField;
  if (items.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        fontSize: '14px',
        margin: '1rem 0'
      }
    }, noItemsMessage || "No items");
  }
  var dataRows = items.map(function (item) {
    return item.status ? Object.assign({}, item, {
      trClassName: getTableRowCssClassForStatus(item.status)
    }) : item;
  });
  var hideTableHeaderCssClass = showTableHeader && showTableHeader === true ? '' : 'hide-table-header';
  var noVerticalTableBordersCssClass = showTableBorders && showTableBorders === true ? '' : 'no-vertical-borders';
  var tableCssClasses = [hideTableHeaderCssClass, noVerticalTableBordersCssClass, className || ''];
  return /*#__PURE__*/_react["default"].createElement(_DataTable["default"], {
    className: tableCssClasses.join(' '),
    style: style,
    data: dataRows,
    columns: getTableColumnsConfig(columns, idFieldName, onItemWillBeRemoved, onUndoItemWillBeAdded, onUndoItemWillBeRemoved, onItemWillBeAdded, disabled, showStatusColumn),
    disabled: disabled,
    condensed: condensed,
    onColumnSort: onColumnSort,
    columnSortDirection: columnSortDirection,
    columnSortField: columnSortField
  });
};
exports.SelectedItemsSummary = SelectedItemsSummary;
SelectedItemsSummary.propTypes = {
  idFieldName: _propTypes["default"].string,
  columns: _propTypes["default"].array,
  items: _propTypes["default"].array.isRequired,
  disabled: _propTypes["default"].bool,
  showStatusColumn: _propTypes["default"].bool,
  showTableHeader: _propTypes["default"].bool,
  showTableBorders: _propTypes["default"].bool,
  condensed: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  onItemWillBeRemoved: _propTypes["default"].func,
  onItemWillBeAdded: _propTypes["default"].func,
  onUndoItemWillBeAdded: _propTypes["default"].func,
  onUndoItemWillBeRemoved: _propTypes["default"].func,
  noItemsMessage: _propTypes["default"].string,
  onColumnSort: _propTypes["default"].func,
  columnSortDirection: _propTypes["default"].string,
  columnSortField: _propTypes["default"].string
};
var _default = SelectedItemsSummary;
exports["default"] = _default;